import React, { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import {Button, Alert} from 'reactstrap';
import {endEvent, startEvent} from "../../slices/event/details/thunk";
import { useDispatch } from "react-redux";

const AddSongButton = ({eventId, startAt}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [countdown, setCountdown] = useState(9);

  useEffect(() => {
    if (showAlert && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      setShowAlert(false);
      setCountdown(9);
    }
  }, [showAlert, countdown]);

  const handleClick = (e) => {
    const btn = e.currentTarget;
    const wasActive = btn.classList.contains("active");
    if (wasActive) {
      dispatch(endEvent(eventId));
    } else {
      dispatch(startEvent(eventId));
      setShowAlert(true);
      setCountdown(9);
    }
    btn.classList.toggle("active");
  };

  return (
    <>
      {showAlert && (
        <Alert
          color="info"
          isOpen={showAlert}
          toggle={() => setShowAlert(false)}
          className="alert-dismissible fade show mb-2 position-relative"
          style={{ width: '100%' }}
        >
          <div className="d-flex align-items-start">
            <i className="ri-information-line me-2 fs-5"></i>
            <div className="flex-grow-1">
              <strong>{t('Important')}:</strong> <Trans i18nKey="event_end_reminder" components={{ strong: <strong /> }} />
            </div>
          </div>
          <span className="badge bg-dark text-white position-absolute bottom-0 end-0 m-2" style={{ zIndex: 1 }}>{countdown}s</span>
        </Alert>
      )}
      <Button color='danger' className={`custom-toggle bg-transparent border-0 shadow-none color-primary px-2 py-0 ${startAt ? "active" : ""}`}
              onClick={handleClick}
      >
        <span className="icon-on"><i className="ri-play-fill align-middle me-2" style={{ fontSize: '1.6rem' }}></i>
          <span>{t('Start Event')}</span>
        </span>
        <span className="icon-off"><i className="ri-stop-fill align-middle me-2" style={{ fontSize: '1.6rem' }}></i> {t('End Event')}</span>
      </Button>
    </>
  );
};

export default AddSongButton;
